import {attr, controller, target} from '@github/catalyst'
import {currencyFormatter, getUnitData} from './utils'
import type {UnitData} from './utils'

@controller('teams-calculator')
export class TeamsCalculatorElement extends HTMLElement {
  @target declare seatCountInput: HTMLInputElement
  get seatCount() {
    return parseInt(this.seatCountInput.value) || 0
  }

  @target declare subtotalElement: HTMLElement
  @attr costPerMonth = 0
  @attr active = false

  declare unit_data: UnitData

  connectedCallback() {
    this.unit_data = getUnitData()
  }

  displayCostPerMonth() {
    this.subtotalElement.textContent = currencyFormatter.format(this.costPerMonth / 100)
  }

  calculate() {
    this.costPerMonth = this.seatCount * this.unit_data.gh_teams_seat_count!.value
  }

  resetButtonClicked(event: PointerEvent) {
    event.preventDefault()
    this.seatCountInput.value = ''
    this.costPerMonth = 0
  }

  getSummaryForCSV() {
    // headers: ['Service', 'Configuration Summary', 'Notes', 'Cost Per Month']
    return [
      [
        'GitHub Teams',
        `"Seats (Users): ${this.seatCount}"`,
        '',
        `"${currencyFormatter.format(this.costPerMonth / 100)}"`,
      ],
    ]
  }

  static observedAttributes = ['data-cost-per-month']
  attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null): void {
    if (oldValue === newValue) {
      return
    }

    if (name === 'data-cost-per-month') {
      this.displayCostPerMonth()
      document.dispatchEvent(
        new CustomEvent('subtotalChanged', {
          detail: {sectionName: 'teamsTotal', amount: this.costPerMonth, active: this.active},
        }),
      )
      document.dispatchEvent(
        new CustomEvent('formDataUpdated', {
          detail: {sectionName: 'teams', resetEnabled: Boolean(this.costPerMonth)},
        }),
      )
    }
  }
}
